import { FC } from 'react';

import { TABS_CONTAINER_CORRECTIONS } from 'utils/constants/common';

import creationWizardTabButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/main_page/creation_wizard_tab_button_click';
import { Tab, Tabs } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import {
    CampaignTarget,
    selectWizardCampaignTarget,
    setWizardCampaignTarget,
    setWizardCpcMode,
    setWizardSelectedProductType,
} from 'store/models/campaignCreationWizard';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    vacancy: 'CampaignCreationWizard.VacancySelectStep.toggle.vacancy',
    website: 'CampaignCreationWizard.VacancySelectStep.toggle.website',
};

export const TargetToggle: FC = () => {
    const dispatch = useDispatch();
    const trl = useTrls();
    const campaignTarget = useSelector(selectWizardCampaignTarget);

    const handleChange = (target: string) => {
        if (target === campaignTarget) {
            return;
        }
        creationWizardTabButtonClick({ tab: target === CampaignTarget.Vacancy ? 'VACANCY' : 'WEBSITE' });
        dispatch([
            setWizardCampaignTarget(target as CampaignTarget),
            setWizardSelectedProductType(null),
            setWizardCpcMode(null),
        ]);
    };

    return (
        <Tabs
            activeItemId={campaignTarget}
            onChange={handleChange}
            mode="primary"
            containerCorrections={TABS_CONTAINER_CORRECTIONS}
        >
            <Tab id={CampaignTarget.Vacancy} aria-label={trl(TrlKeys.vacancy)} data-qa="ad-create-target-vacancy">
                {trl(TrlKeys.vacancy)}
            </Tab>
            <Tab id={CampaignTarget.Website} aria-label={trl(TrlKeys.website)} data-qa="ad-create-target-website">
                {trl(TrlKeys.website)}
            </Tab>
        </Tabs>
    );
};
